import { DateTime } from 'luxon';
import { searchDataStore } from '../../stores';
import { FunnelQueryCookieObject } from '../../cookie-utils';
import { GTMSharedContext, GTMSharedContextStore } from '../context';

export const calculateTripDuration = (
  journeyType: string,
  flight: { localDepartureDateTime: string } | undefined,
  flightQuery: FunnelQueryCookieObject
) => {
  if (journeyType === 'One Way') {
    return '';
  }
  const searchStore = searchDataStore.getState();
  const sharedContext: GTMSharedContext = GTMSharedContextStore.getState();

  let outboundDate: string;
  let inboundDate: string;

  if (
    searchStore.journeyPairs &&
    searchStore.journeyPairs.length > 0 &&
    searchStore.journeyPairs[0].outbound &&
    searchStore.journeyPairs[0].inbound
  ) {
    outboundDate = Object.keys(searchStore.journeyPairs[0].outbound.flights)[1];
    inboundDate = Object.keys(searchStore.journeyPairs[0].inbound.flights)[1];
  } else if (flightQuery.returnDate) {
    outboundDate = flightQuery.outboundDate;
    inboundDate = flightQuery.returnDate;
  } else {
    return '';
  }

  return flight
    ? sharedContext.getTripDuration(
        false,
        DateTime.fromFormat(outboundDate, 'y-MM-dd'),
        DateTime.fromFormat(inboundDate, 'y-MM-dd')
      )
    : '';
};
